var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-layout",
    {
      staticClass: "verHistoricoProveedor",
      attrs: { row: "", "justify-center": "" }
    },
    [
      _c(
        "v-dialog",
        {
          attrs: {
            persistent: "",
            fullscreen: "",
            "hide-overlay": "",
            transition: "dialog-bottom-transition"
          },
          model: {
            value: _vm.dialog,
            callback: function($$v) {
              _vm.dialog = $$v
            },
            expression: "dialog"
          }
        },
        [
          _c(
            "v-card",
            { attrs: { id: "cardDivTV" } },
            [
              _c(
                "v-toolbar",
                { attrs: { dark: "", color: "primary", fixed: "" } },
                [
                  _c(
                    "v-btn",
                    {
                      attrs: { icon: "", dark: "" },
                      on: {
                        click: function($event) {
                          return _vm.handleClosed()
                        }
                      }
                    },
                    [_c("v-icon", [_vm._v("close")])],
                    1
                  ),
                  _c("v-toolbar-title", [
                    _vm._v(
                      "Detalle de Nota de Venta de\n          " +
                        _vm._s(_vm.localData["Nombre NDV"])
                    )
                  ]),
                  _c("v-spacer")
                ],
                1
              ),
              _c("br"),
              _c("br"),
              _c("br"),
              _c("div", [
                _c(
                  "div",
                  { staticClass: "cardnew", attrs: { align: "center" } },
                  [
                    _c("br"),
                    _c(
                      "v-flex",
                      { attrs: { md10: "" } },
                      [
                        _c(
                          "v-card",
                          { staticClass: "rounded-card" },
                          [
                            _c(
                              "v-container",
                              { attrs: { "grid-list-md": "" } },
                              [
                                _c(
                                  "div",
                                  { attrs: { align: "left" } },
                                  [
                                    _c(
                                      "v-flex",
                                      { attrs: { md12: "" } },
                                      [
                                        _c(
                                          "v-flex",
                                          { attrs: { sm12: "", md12: "" } },
                                          [
                                            _c(
                                              "v-tabs",
                                              { staticClass: "ndv_modal_tabs" },
                                              [
                                                _c(
                                                  "v-tab",
                                                  {
                                                    on: {
                                                      click: function($event) {
                                                        _vm.step = "ndv"
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                          Nota de Venta\n                        "
                                                    )
                                                  ]
                                                ),
                                                _c(
                                                  "v-tab",
                                                  {
                                                    on: {
                                                      click: function($event) {
                                                        _vm.step = "attentions"
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                          Atención\n                        "
                                                    )
                                                  ]
                                                ),
                                                _c(
                                                  "v-tab",
                                                  {
                                                    on: {
                                                      click: function($event) {
                                                        _vm.step = "products"
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                          Detalle de Equipos, Periféricos y Servicios\n                        "
                                                    )
                                                  ]
                                                ),
                                                _c(
                                                  "v-tab",
                                                  {
                                                    on: {
                                                      click: function($event) {
                                                        _vm.step =
                                                          "reservations"
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                          Detalle de Reserva, Asignación y\n                          Preparación\n                        "
                                                    )
                                                  ]
                                                )
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        ),
                                        _c("v-divider"),
                                        !_vm.loading
                                          ? _c(
                                              "v-flex",
                                              {
                                                attrs: {
                                                  sm12: "",
                                                  md12: "",
                                                  "mt-5": ""
                                                }
                                              },
                                              [
                                                _vm.step === "ndv"
                                                  ? _c("TabNDV", {
                                                      attrs: {
                                                        data: _vm.localData
                                                      }
                                                    })
                                                  : _vm.step === "products" &&
                                                    _vm.dataApi.products
                                                      .length > 0
                                                  ? _c("TabProducts", {
                                                      attrs: {
                                                        data:
                                                          _vm.dataApi.products,
                                                        ndv:
                                                          _vm.localData[
                                                            "Nombre NDV"
                                                          ],
                                                        ndvnumero:
                                                          _vm.localData
                                                            .ndvnumero
                                                      }
                                                    })
                                                  : _vm.step ===
                                                      "reservations" &&
                                                    _vm.dataApi.reservations
                                                      .length > 0
                                                  ? _c("TabReservations", {
                                                      attrs: {
                                                        cerrar:
                                                          _vm.handleClosed,
                                                        data: _vm.dataApi.reservations.map(
                                                          function(
                                                            reservation
                                                          ) {
                                                            return Object.assign(
                                                              {},
                                                              reservation,
                                                              {
                                                                "Nombre NDV":
                                                                  _vm.localData[
                                                                    "Nombre NDV"
                                                                  ]
                                                              }
                                                            )
                                                          }
                                                        )
                                                      }
                                                    })
                                                  : _vm.step === "attentions" &&
                                                    _vm.dataApi.attentions
                                                      .length > 0
                                                  ? _c("TabAttentions", {
                                                      attrs: {
                                                        data:
                                                          _vm.dataApi.attentions
                                                      }
                                                    })
                                                  : _c("GridComponent", {
                                                      staticClass:
                                                        "ag-theme-material",
                                                      staticStyle: {
                                                        height: "300px"
                                                      },
                                                      attrs: {
                                                        "grid-options":
                                                          _vm.gridOptions
                                                      }
                                                    })
                                              ],
                                              1
                                            )
                                          : _vm._e()
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _c("br")
                              ]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ])
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }